import { BaseCriteriaModel } from './base-criteria.model';
import { Optional } from 'typescript-optional';

export class InventoryTransactionLineFactQueryCriteriaClass extends BaseCriteriaModel {
  report_code?: Optional<string> = Optional.empty();;
  report_type?: Optional<string> = Optional.empty();;
  item_code?: Optional<string> = Optional.empty();;
  item_guid?: Optional<string> = Optional.empty();;
  guid_comp?: Optional<string> = Optional.empty();;
  guid_branch?: Optional<string> = Optional.empty();;
  guid_store?: Optional<string> = Optional.empty();;
  param_code?: Optional<string> = Optional.empty();;
  param_name?: Optional<string> = Optional.empty();;
  param_type?: Optional<string> = Optional.empty();;
  date1_month?: Optional<string> = Optional.empty();;
  date1_year?: Optional<string> = Optional.empty();;
  date1_day?: Optional<string> = Optional.empty();;
  exist_serial_number?: Optional<string> = Optional.empty();;
}


export class InventoryTransactionLineFactCriteriaModelQuery {
  query = '';

  constructor(InventoryTransactionLineFactQueryCriteriaClassCriteriaModel: InventoryTransactionLineFactQueryCriteriaClass) {
    if (!InventoryTransactionLineFactQueryCriteriaClassCriteriaModel) {
      return;
    }

    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.report_code.filter(x => x !== '').map(x => '&report_code=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.report_type.filter(x => x !== '').map(x => '&report_type=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.item_code.filter(x => x !== '').map(x => '&item_code=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.item_guid.filter(x => x !== '').map(x => '&item_guid=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.guid_comp.filter(x => x !== '').map(x => '&guid_comp=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.guid_branch.filter(x => x !== '').map(x => '&guid_branch=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.guid_store.filter(x => x !== '').map(x => '&guid_store=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.date1_month.filter(x => x !== '').map(x => '&date1_month=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.date1_year.filter(x => x !== '').map(x => '&date1_year=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.date1_day.filter(x => x !== '').map(x => '&date1_day=' + x).orElse('');
    this.query += InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.exist_serial_number.filter(x => x !== '').map(x => '&exist_serial_number=' + x).orElse('');

    this.query += '&status=' + InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.status;
    this.query += '&orderBy=' + InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.orderBy;
    this.query += '&order=' + InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.order;
    this.query += '&offset=' + InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.offset + '&limit=' + InventoryTransactionLineFactQueryCriteriaClassCriteriaModel.limit;
  }


}
